import React, {useState} from 'react';
import {
   View,
   TouchableOpacity,
   StyleSheet,
   Image,
   Platform,
   Text,
} from 'react-native';
import {FONT_FAMILY_REGULAR} from '../../utils/utils';
import {selectScreenOrientation} from '../../redux/slices/ScreenOrientationSlice';
import {useSelector} from 'react-redux';

const TutorialOverlayView = props => {
   const [isVisible, setIsVisible] = useState(true);
   const isLandscapeMode = useSelector(selectScreenOrientation);

   if (!isVisible) {
      return null; // Return null if the overlay is not visible
   }

   return (
      <TouchableOpacity
         style={[
            styles.parentOverlay,
            {
               ...Platform.select({
                  web: {
                     zIndex: 1000,
                     transform: 'translate3d(0, 0, 0)',
                  },
               }),
            },
         ]}
         activeOpacity={1}
         onPress={() => {
            setIsVisible(false);
            props.hideOverlay();
         }}>
         {/* Content inside the overlay */}
         <View style={styles.overlay}>{/* Add your content here */}</View>
         <View
            style={[
               styles.tutorialMessageView,
               {marginBottom: isLandscapeMode ? 45 : 30},
            ]}>
            <Image
               source={require('../../assets/arrow_down.png')}
               style={styles.tutorialDownIcon}
            />
            <Text style={styles.message}>
               {'"Scroll down for more options."'}
            </Text>
         </View>
      </TouchableOpacity>
   );
};

const styles = StyleSheet.create({
   overlay: {
      flex: 1,
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      backgroundColor: '#000000',
      opacity: 0.5,
   },
   parentOverlay: {
      flex: 1,
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
   },
   tutorialMessageView: {
      width: 240,
      height: 94,
      borderRadius: 8,
      backgroundColor: '#313131',
      marginRight: 20,
   },
   tutorialDownIcon: {
      width: 40,
      height: 40,
      top: 12,
      left: 100,
      marginBottom: 12,
   },
   message: {
      fontSize: 14,
      fontFamily: FONT_FAMILY_REGULAR,
      color: 'white',
      textAlign: 'center',
      fontWeight: '400',
      top: 12,
   },
});

export default TutorialOverlayView;
